import React, {useContext,useEffect,useMemo} from 'react'
import {useSelector,useDispatch} from 'react-redux'

import Header from '../map/components/Header'
import PopupDefault from '../map/components/popups/PopupDefault'

import MemberHeader from './parts/MemberHeader'
import MemberFooter from './parts/MemberFooter'

const AllDownloaded = () => {
  const setApp = useDispatch();
  const {first_name,last_name} = useSelector(s=>s.auth);

  useEffect(()=>{
    setApp({type:'_AUTH_LOGGED',payload:[window.auth.first_name,window.auth.last_name]})
  },[])

  return !first_name ? null : (
    <>
      <Header/>
      <PopupDefault/>

      <section id="member-area">

        <MemberHeader title="All Downloaded Datasets"/>

        <div id="breadcrumb">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-xs-12">
                <div className="breadcrumb-items">
                    <ul id="breadcrumbs" className="breadcrumbs">
                      <li><a className="bread-link bread-home" href="/" title="Home">Home/Map</a></li>
                      <li><strong className="bread-current">Member Area</strong></li>
                    </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col">
              <h5 className="member-block-title">All downloaded datasets:</h5>

            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col">
              <table className="table table-hover">
                <thead className="thead-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Title</th>
                    <th scope="col">Author(s)</th>
                    <th scope="col">Type</th>
                    <th scope="col">Species</th>
                    <th scope="col">Location</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Coad 2007 Hunting in central Gabon</td>
                    <td>Coad L.</td>
                    <td>Harvest</td>
                    <td>ANIMALIA, Atherurus africanus, BOVIDAE Cephalophus, BUCEROTIFORMES BUCEROTIDAE, Bdeogale nigripes, Bitis gabonica, CARNIVORA HERPESTIDAE1, CHORDATA AVES, Cephalophus dorsalis, Cephalophus leucogaster, Cephalophus monticola, Cephalophus nigrifrons, Cephalophus ogilbyi, Cercopithecus cephus, Cercopithecus nictitans, Cercopithecus pogonias, Civettictis civetta, Colobus satanas, Corythaeola cristata, Cricetomys emini, DECAPODA POTAMONAUTIDAE, Dendrohyrax arboreus, Francolinus squamatus, Genetta servalina, Hyemoschus aquaticus, Kinixys erosa, Lophocebus albigena, MAMMALIA RODENTIA, MANIDAE Phataginus, Mandrillus sphinx, Naja melanoleuca, Nandinia binotata, PRIMATES CERCOPITHECIDAE, Pan troglodytes ssp. troglodytes, Perodicticus potto, Potamochoerus porcus, Potamogale velox, Python sebae, RODENTIA ANOMALURIDAE, RODENTIA SCIURIDAE, SCIURIDAE Funisciurus, SQUAMATA SERPENTES, Tauraco persa ssp. persa, Thryonomys swinderianus, Tragelaphus spekii, Varanus niloticus</td>
                    <td>Gabon (Site11, Site12)</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Dupain et al 2012 Market survey Democratic Republic of Congo</td>
                    <td>Dupain J., Nackoney J., Vargas J. M., Johnson P. J., Farfán M. A., Bofaso M., Fa J. E.</td>
                    <td>Market</td>
                    <td>Allenopithecus nigroviridis, Atherurus africanus, Caracal aurata, Cephalophus callipygus, Cephalophus dorsalis, Cephalophus nigrifrons, Cephalophus silvicultor, Cercopithecus ascanius ssp. whitesidei, Cercopithecus dryas, Cercopithecus hamlyni, Cercopithecus neglectus, Cercopithecus wolfi ssp. wolfi, Civettictis civetta, Colobus angolensis, Cricetomys emini, Crossarchus obscurus, Dendrohyrax arboreus, HERPESTIDAE Herpestes, Hyemoschus aquaticus, Hylochoerus meinertzhageni, Lophocebus aterrimus, Mellivora capensis, Nandinia binotata, Orycteropus afer, Pan paniscus, Phataginus tricuspis, Philantomba monticola, Piliocolobus tholloni, Potamochoerus porcus, Protoxerus stangeri, Smutsia gigantea, Tragelaphus spekii</td>
                    <td>Democratic Republic of the Congo (Site10)</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Abugiche 2008 group hunting data from 14 villages near the Banyang-Mbo Wildlife Sanctuary, South West Cameroon</td>
                    <td>Abugiche S. A.</td>
                    <td>Harvest</td>
                    <td>Arctocebus calabarensis, Atherurus africanus, Bitis gabonica, CARNIVORA HERPESTIDAE, CARNIVORA MUSTELIDAE, COLUMBIFORMES COLUMBIDAE, Cephalophus dorsalis, Cephalophus monticola, Cephalophus ogilbyi, Cephalophus silvicultor, Ceratogymna atrata, Cercocebus torquatus, Cercopithecus erythrotis, Cercopithecus mona, Cercopithecus nictitans, Cercopithecus pogonias, Civettictis civetta, Cricetomys gambianus, Crossarchus obscurus, Dendroaspis jamesoni, ELAPIDAE Naja, Guttera plumifera, Gypohierax angolensis, Hyemoschus aquaticus, MAMMALIA CHIROPTERA, Mandrillus leucophaeus, Nandinia binotata, Osteolaemus tetraspis, PHOLIDOTA MANIDAE, PROCAVIIDAE Dendrohyrax, Pan troglodytes, Potamochoerus porcus, Protoxerus stangeri, Psittacus erithacus, RODENTIA SCIURIDAE, Rattus norvegicus, SQUAMATA PYTHONIDAE, Sciurocheirus alleni, TESTUDINES TESTUDINIDAE, Thryonomys swinderianus, Tragelaphus scriptus, VIVERRIDAE Genetta, Varanus niloticus</td>
                    <td>Cameroon (Site154)</td>
                  </tr>
                </tbody>
              </table>

              <br/><br/><br/><br/><br/>
            </div>
          </div>
        </div>

        <MemberFooter/>

      </section>

    </>
  )
}

export default AllDownloaded
